import { useState } from "react";
import "./contact.css";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    requirement: "",
  });

  const [status, setStatus] = useState({
    loading: false,
    error: null,
    success: false,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Basic Validation
    if (!formData.name || !formData.email || !formData.phone || !formData.requirement) {
      setStatus({ loading: false, error: "Please fill all fields.", success: false });
      return;
    }

    setStatus({ loading: true, error: null, success: false });

    try {
      const response = await fetch("https://overseas-backend-1-548y.onrender.com/api/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || "Failed to submit the form.");
      }

      setStatus({ loading: false, error: null, success: true });
      setFormData({
        name: "",
        email: "",
        phone: "",
        requirement: "",
      });
    } catch (error) {
      console.error("Submission error:", error);
      setStatus({
        loading: false,
        error: error.message || "An error occurred while submitting the form.",
        success: false,
      });
    }
  };

  return (
    <div className="contact-container">
      <h2>Enquire</h2>
      <p>Let's create something incredible together, let's talk!</p>

      <div className="contact-container-page">
        {/* Form Section */}
        <form onSubmit={handleSubmit} className="contact-form">
          <label>Full Name</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
            placeholder="Enter your full name"
          />

          <label>Email Address</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
            placeholder="Enter your email"
          />

          <label>Phone Number</label>
          <input
            type="tel"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            required
            placeholder="Enter your phone number"
          />

          <label>Brief Requirement</label>
          <textarea
            name="requirement"
            value={formData.requirement}
            onChange={handleChange}
            required
            placeholder="What are you looking for?"
          />

          <button type="submit" className="submit-button" disabled={status.loading}>
            {status.loading ? "Sending..." : "SUBMIT"}
          </button>

          {status.success && <p className="success-msg">✅ Message sent & saved successfully!</p>}
          {status.error && <p className="error-msg">❌ {status.error}</p>}
        </form>

        {/* Contact Info */}
        <div className="contact-info">
          <p><strong>📞 CALL US</strong></p>
          <p>+91 9618001019</p>
          <p><strong>📧 EMAIL US</strong></p>
          <p>Clyraoverseas@gmail.com</p>
          <p><strong>🕐 OFFICE HOURS</strong></p>
          <p>10:00 AM – 5:00 PM</p>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;
